import React from "react";
import "../Assets/Styles/SliderSection.css";
import History from "../Components/History/History";
import { Col, Container, Row } from "reactstrap";
import { useRef, useState } from "react";
import Culture from "./Culture/Culture";
import Testimonials from "./Testimonials/Testimonials";
import { useAnimateOnScroll } from "../Hooks/useAnimationScroll";
import { useTranslation } from "../Hooks/useTranslation"; // Import the hook
import { Link } from "react-router-dom";

const componentMap = {
  AM: <History />,
  Culture: <Culture />,
  Testimonials: <Testimonials />,
};

const Credentials = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("AM");
  // Reference to the scroll target section
  const scrollToRef = useRef(null);

  // Scroll handler
  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      id="About-Us"
      className={`supeior-rating lg:min-h-screen flex items-center lg:items-start bg-[#F7F6F2] lg:bg-[#FAFAFA] py-12 md:py-16 lg:pt-[266px] [@media(min-width:1920px)]:pt-[399px] ${
        change === "AM" ? "history-bg" : ""
      }`}
    >
      <Container>
        <div className="lg:flex lg:flex-row lg:items-start gap-x-8">
          <div className="lg:max-w-[454px] [@media(min-width:1920px)]:max-w-[673px] mt-0 reveal-up  lg:pl-0 pl-4">
            <h3 className="text-[24px] leading-[28px] max-w-[449px] md:text-[30px] md:leading-[33px] xl:text-[40px] xl:leading-[44px] font-semibold lg:mb-6 tracking-tight extra-title-heading ">
              {translations.ourCredentialHeading}
            </h3>

            <div className="active-section flex lg:justify-center justify-space-between gap-2 bg-white rounded-full mt-4 mb-4 mr-4 md:max-w-[200px] xl:max-w-[266px]">
              <button
                onClick={() => setChange("AM")}
                className={`extra-btn-font flex-1 content text-[14px] md:text-[10.5px] xl:text-[14px] ${
                  change === "AM" ? "active bg-[#FFE9B1] font-semibold" : ""
                } font-medium  text-black py-3 lg:py-2 xl:py-3 px-4 lg:px-3 xl:px-4 rounded-full md:w-1/3`}
              >
                {translations.historyTab}
              </button>
              <button
                onClick={() => setChange("Culture")}
                className={`extra-btn-font flex-1 content text-[14px] md:text-[10.5px] xl:text-[14px] ${
                  change === "Culture"
                    ? "active bg-[#FFE9B1] font-semibold"
                    : ""
                } font-medium  text-black py-3 lg:py-2 xl:py-3 px-4 lg:px-3 xl:px-4 rounded-full md:w-1/3`}
              >
                {translations.cultureTab}
              </button>
            </div>

            <p
              className={`text-[14px] md:text-[10.5px] md:leading-[16.5px] xl:text-[14px] xl:leading-normal mb-4 lg:mb-8 [@media(min-width:1920px)]:mt-[66px] text-left extra-para-vs hidden lg:block ${
                change === "AM" ? "lg:text-white" : "text-black"
              }`}
            >
              {translations.historyDescription}
            </p>
            {change === "Culture" && (
              <Link
                to="/about"
                className="text-[#00363C] font-bold bg-white text-[14px] md:text-[10.5px] xl:text-[14px] rounded-full px-5 text-center mb-4 gotofaqbtn hover:bg-[#eeecf3] hidden lg:inline-flex extra-btn-font"
              >
                {translations.historyLearnMore}
              </Link>
            )}
          </div>
          <div className="lg:flex-1">{componentMap[change] || null}</div>
        </div>
      </Container>
    </div>
  );
};

export default Credentials;
